package com.exura.features.newauth.domain.model

enum class UserType {
    RECEIVER,
    PROVIDER;
}
